import React from "react";
import Navbar from "../components/navbar/Navbar";
import Sidebar from "./../components/basket/Sidebar";
import MenuOptions from "./../components/basket/MenuOptions";
import Modal from "../components/keyboard/Keyboard-modal";
import TablePlanModal from "./../components/tablePlan/TablePlan-Modal";
import PaymentContainer from "../components/payment/Payment-container";

const Dashboard = () => {
    return (
        <div className='wrapper flex flex-1 '>
            <div className='flex max-w-screen-2xl flex-1  flex-col'>
                <PaymentContainer />
                <Navbar />
                <MenuOptions />
            </div>
            <Sidebar />
            <Modal />
            <TablePlanModal />
        </div>
    );
};

export default Dashboard;
